import React from 'react';

const CertificationBadge = () => {
  return (
    <section className="py-6 sm:py-8 bg-white border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center">
          <div className="inline-flex items-center gap-4 sm:gap-5 px-5 sm:px-6 py-3 sm:py-4 rounded-xl bg-slate-50 border border-slate-200">
            {/* Logo */}
            <img 
              src={process.env.REACT_APP_CERT_LOGO || "https://customer-assets.emergentagent.com/job_bess-living/artifacts/fp4rf3us_CertCO2.png"}
              alt="CertCO2 Zertifizierung"
              className="w-16 sm:w-20 lg:w-24 h-auto object-contain flex-shrink-0"
            />
            
            {/* Text */}
            <div className="flex flex-col">
              <span className="text-xs sm:text-sm text-slate-500 font-medium uppercase tracking-wide">
                Zertifiziert
              </span>
              <span className="text-sm sm:text-base text-slate-700 font-medium">
                CertCO2 – zertifizierte CO₂-Nachweise
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationBadge;
